import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionBanner',
  setup(__props) {

const auth = useAuthStore();
const { subscriptionStatus, needsAttention, getWarningMessage } = useSubscriptionStatus();

// Banner helper functions
const getBannerTitle = () => {
  switch (subscriptionStatus.value.status) {
    case "paused":
      return "Subscription Paused";
    case "cancelled":
      return "Subscription Cancelled";
    case "past_due":
      return "Payment Past Due";
    case "expired":
      return "Subscription Expired";
    case "no_subscription":
      return "No Active Subscription";
    default:
      return "Subscription Notice";
  }
};

const getBannerColor = () => {
  switch (subscriptionStatus.value.status) {
    case "expired":
      return "error";
    case "past_due":
      return "warning";
    case "paused":
      return "info";
    case "cancelled":
      return "neutral";
    case "no_subscription":
      return "primary";
    default:
      return "warning";
  }
};

const getBannerIcon = () => {
  switch (subscriptionStatus.value.status) {
    case "expired":
      return "i-heroicons-x-circle";
    case "past_due":
      return "i-heroicons-credit-card";
    case "paused":
      return "i-heroicons-pause-circle";
    case "cancelled":
      return "i-heroicons-stop-circle";
    case "no_subscription":
      return "i-heroicons-rocket-launch";
    default:
      return "i-heroicons-exclamation-triangle";
  }
};

const getBannerActions = () => {
  const actions = [];

  if (subscriptionStatus.value.status === "paused") {
    actions.push({
      label: "Resume",
      variant: "outline",
      to: "/settings/billing",
    });
  }

  if (
    subscriptionStatus.value.status === "past_due" ||
    subscriptionStatus.value.status === "expired"
  ) {
    actions.push({
      label: "Update Payment",
      variant: "outline",
      to: "/settings/billing",
    });
  }

  if (subscriptionStatus.value.status === "no_subscription") {
    actions.push({
      label: "Start Trial",
      variant: "outline",
      to: "/settings/billing",
    });
  }

  // Always add a "Manage" action
  actions.push({
    label: "Manage",
    variant: "outline",
    to: "/settings/billing",
  });

  return actions;
};

return (_ctx: any,_cache: any) => {
  const _component_UBanner = _resolveComponent("UBanner")!

  return (_unref(needsAttention) && _unref(auth).user?.role === 'owner')
    ? (_openBlock(), _createBlock(_component_UBanner, {
        key: 0,
        id: `subscription-${_unref(subscriptionStatus).status + Math.random()}`,
        title: getBannerTitle(),
        color: getBannerColor(),
        icon: getBannerIcon(),
        actions: getBannerActions(),
        close: "",
        class: "relative z-[9999]"
      }, null, 8, ["id", "title", "color", "icon", "actions"]))
    : _createCommentVNode("", true)
}
}

})